import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { GenericPagePropsProvider } from './components/stack/hooks/content/useGenericPageProps';
import { GenericPage } from './components/stack/views/GenericPage/GenericPage';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import { DefaultLayout, drawDefaultLayout } from './components/layout/DefaultLayout';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('content-hub');
  if (!container) return drawDefaultLayout();
  const root = createRoot(container);

  root.render(
    <BaseContentProvider>
      <GenericPagePropsProvider>
        <DefaultLayout>
          <GenericPage />
        </DefaultLayout>
      </GenericPagePropsProvider>
    </BaseContentProvider>
  );
});
